/* import __COLOCATED_TEMPLATE__ from './edit-production.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { handleErrorResponse } from 'sh-www/utils/handles-errors';
import { PRODUCTION_STATUSES } from 'sh-www/models/production';
import { showModal } from 'sh-www/utils/modal-controls';
import CreateShellCompanyModalComponent from 'sh-www/components/modals/admin/create-shell-company';

const PRODUCTION_STATUS_OPTIONS = Object.entries(PRODUCTION_STATUSES).map(
  ([key, value]) => ({
    key: value,
    value: key,
  }),
);

const filterInvalid = (obj) => Object.entries(obj).reduce((accum, [key, value]) => {
  const isEmpty = value == null || Number.isNaN(value) || value === '';

  if (!isEmpty) {
    accum[key] = value;
  }

  return accum;
}, { });

class EditProductionComponent extends Component {
  @tracked title = this.args.title ?? '';
  @tracked description = this.args.description ?? '';
  @tracked budget = `${this.args.budget ?? ''}`;
  @tracked amount = `${this.args.amount ?? ''}`;
  @tracked status = `${this.args.status ?? 0}`;
  @tracked deadline = this.args.deadline ?? null;
  @tracked client_id = '';
  @tracked errors = { };

  get statusOptions() {
    return PRODUCTION_STATUS_OPTIONS;
  }

  get statusText() {
    return PRODUCTION_STATUSES[this.status];
  }

  get deadlineText() {
    return this.deadline?.toLocaleDateString('en-US') ?? '';
  }

  @action
  createOffPlatformCompany() {
    showModal(this, CreateShellCompanyModalComponent, {
      onComplete: (company) => {
        this.client_id = company.id;
      },
    });
  }

  @action
  handleNumeric(e) {
    switch (e.code) {
      case 'Period':
      case 'Comma':
        e.preventDefault();
        break;
    }
  }

  @action
  handleInput(field, value) {
    this[field] = value;

    if (this.errors[field]) {
      this.errors = { ...this.errors, [field]: undefined };
    }
  }

  @action
  handleStatus({ value }) {
    this.handleInput('status', value);
  }

  @dropTask
  *handleSubmit(e) {
    e.preventDefault();

    this.errors = { };

    try {
      yield this.args.onsubmit({
        title: this.title.trim(),
        description: this.description.trim(),
        deadline: this.deadline,

        ...filterInvalid({
          budget: Number.parseInt(this.budget.trim()) * 100,
          amount: Number.parseInt(this.amount.trim()) * 100,
          status: Number.parseInt(this.status),
          client_id: Number.parseInt(this.client_id),
        }),
      });
    } catch (e) {
      handleErrorResponse(this, e, [
        'title',
        'description',
        'budget',
        'amount',
        'status',
        'client_id',
        'deadline',
      ]);
    }
  }
}

export default EditProductionComponent;
